import ToastPlugin from 'vux/src/plugins/toast/index.js'


const MyToastPlugin = Object.create(null)

MyToastPlugin.install = function (Vue) {
Vue.use(ToastPlugin)

Vue.prototype.$toast = function (msg) {
if (this.$vux.toast) {
this.$vux.toast.show({
type: 'text',
text: msg,
position: 'middle'
})
} else {
alert(msg)
}
}
}

export default MyToastPlugin


// WEBPACK FOOTER //
// ./src/plugins/toastPlugin.js